var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "volume_up_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#volume_up_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 16.288a6.864 6.864 0 00-1.1-3.788 6.822 6.822 0 00-2.95-2.563 1.114 1.114 0 01-.55-.537.948.948 0 01-.05-.738c.1-.266.28-.458.537-.575a.93.93 0 01.788 0 8.806 8.806 0 013.875 3.288c.967 1.475 1.45 3.113 1.45 4.913 0 1.8-.483 3.437-1.45 4.912a8.806 8.806 0 01-3.875 3.288.93.93 0 01-.788 0 .988.988 0 01-.537-.575.948.948 0 01.05-.738c.117-.242.3-.42.55-.538a6.822 6.822 0 002.95-2.562 6.864 6.864 0 001.1-3.787zm-12 3.024H8a.967.967 0 01-.713-.287.968.968 0 01-.287-.712v-4c0-.284.096-.521.287-.713A.967.967 0 018 13.313h3l3.3-3.3c.317-.317.68-.388 1.087-.213.409.175.613.487.613.938v11.15c0 .45-.204.762-.613.937-.408.175-.77.104-1.087-.212l-3.3-3.3zm9.5-3c0 .7-.158 1.363-.475 1.988a4.46 4.46 0 01-1.25 1.537.493.493 0 01-.512.013.46.46 0 01-.263-.438v-6.25c0-.2.087-.345.262-.437a.493.493 0 01.513.013 4.68 4.68 0 011.25 1.575c.317.633.475 1.3.475 2z",
    fill: "#fff"
  }))));
}
export default SvgVolumeUp;